<template>
  <div class="auth__options text-center">
    <h2 class="text-white ml-10 md:ml-0 main__auth__title">
      Realiza<br />
      envíos más <br />
      fácil y online
    </h2>
    <p class="auth__descriptions md:text-lg text-left">
      Para tu emprendimiento o empresa <br />
      en Lima y Callao
    </p>
    <div class="text-center content__buttons">
      <router-link
        :to="{ name: 'register' }"
        class="font-neue uppercase register__button"
      >
        regístrate
      </router-link>
      <router-link
        :to="{ name: 'login' }"
        class="font-neue uppercase auth__button"
      >
        inicia sesíon
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthOptions",
};
</script>

<style lang="scss" scoped>
.main__auth__title {
  font-size: 3.2rem;
  font-weight: 400;
  text-align: left;
  line-height: 1;
  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
}
.auth__options::before {
  content: "";
  width: 100%;

  background-color: #474D59;
}
.auth__options {
  width: 300px;
  background-color: #73c9ff;
  padding: 14% 7%;
  @media (min-width: 768px) {
    width: 470px;
  }
}
.auth__descriptions {
  margin: 30px 0;
  color: white;
}
.register__button {
  width: 48%;
  padding: 10px 0em;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  color: #73c9ff;
  text-decoration: none;
  font-size: 12px;
  @media only screen and (min-width: 768px) {
    font-size: 1rem;
    padding: 15px 0em;
  }
}
.auth__button {
  padding: 10px 0em;
  width: 48%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0px;
  text-decoration: none;
  background-color: #0A50E6;
  color: #73c9ff;
  font-size: 12px;
  @media (min-width: 768px) {
    font-size: 1rem;
    padding: 15px 0em;
  }
}
.content__buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  @media (min-width: 768px) {
    justify-content: center;
    flex-direction: row;
  }
}
h2 {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 43px;
  margin-left: 1%;
  @media (min-width: 768px) {
    margin-left: 0%;
  }
}
</style>
